import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
const privacyContent = {
  title: 'Política de Privacidad',
  sections: [{
    heading: 'Información que Recopilamos',
    body: 'Recopilamos únicamente la información necesaria para procesar tu compra: nombre, correo electrónico y datos de pago. Estos datos son procesados de forma segura a través de Hotmart, nuestra plataforma de pagos.'
  }, {
    heading: 'Uso de la Información',
    body: 'Tu información personal se utiliza exclusivamente para: entregar el producto digital adquirido a tu correo electrónico, enviarte actualizaciones relacionadas con tu compra, y brindarte soporte si lo necesitas.'
  }, {
    heading: 'Protección de Datos',
    body: 'No vendemos, compartimos ni alquilamos tu información personal a terceros. Todos los datos se manejan con estricta confidencialidad y bajo los estándares de seguridad de la plataforma Hotmart.'
  }, {
    heading: 'Cookies',
    body: 'Nuestro sitio puede utilizar cookies para mejorar tu experiencia de navegación. Puedes configurar tu navegador para rechazar cookies si lo prefieres.'
  }, {
    heading: 'Tus Derechos',
    body: 'Tienes derecho a acceder, rectificar o eliminar tus datos personales en cualquier momento. Para ejercer estos derechos, puedes contactarnos a través de la plataforma Hotmart.'
  }]
};
const termsContent = {
  title: 'Términos y Condiciones',
  sections: [{
    heading: 'Producto Digital',
    body: 'El Sistema Keto Criollo es un producto digital en formato PDF que se entrega de forma inmediata a tu correo electrónico tras confirmar el pago. No se realizan envíos físicos.'
  }, {
    heading: 'Uso Personal',
    body: 'El contenido adquirido es para uso personal y no puede ser reproducido, distribuido, modificado o revendido sin autorización expresa del autor.'
  }, {
    heading: 'Resultados',
    body: 'Los resultados pueden variar de persona a persona. La información proporcionada es de carácter educativo y no reemplaza el consejo médico profesional. Consulta a tu médico antes de iniciar cualquier plan alimenticio.'
  }, {
    heading: 'Política de Reembolso',
    body: 'Ofrecemos una garantía de satisfacción de acuerdo con las políticas de Hotmart. Si no estás satisfecho con el producto, puedes solicitar un reembolso dentro del plazo establecido por la plataforma.'
  }, {
    heading: 'Modificaciones',
    body: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. Las actualizaciones serán publicadas en esta misma página.'
  }]
};
function Modal({
  isOpen,
  onClose,
  content
}: {
  isOpen: boolean;
  onClose: () => void;
  content: typeof privacyContent;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-34">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-35" />
      <div className="relative bg-[#1A1A1A] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-36">
        {/* Header */}
        <div className="sticky top-0 bg-[#1A1A1A] border-b border-white/10 px-6 py-4 flex items-center justify-between z-10" data-id="element-37">
          <h2 className="font-montserrat font-bold text-xl text-white" data-id="element-38">
            {content.title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-white/10 transition-colors" data-id="element-39">
            <XIcon className="w-5 h-5 text-gray-400" data-id="element-40" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(85vh-64px)] space-y-6" data-id="element-41">
          {content.sections.map((section, i) => <div key={i} data-id="element-42">
              <h3 className="font-montserrat font-bold text-lg text-[#F5C518] mb-2" data-id="element-43">
                {section.heading}
              </h3>
              <p className="font-inter text-gray-300 leading-relaxed" data-id="element-44">
                {section.body}
              </p>
            </div>)}
          <p className="font-inter text-sm text-gray-500 pt-4 border-t border-white/5" data-id="element-45">
            Última actualización: Febrero 2026
          </p>
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#0A0A0A] border-t border-white/5 py-8 px-4" data-id="element-46">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-47">
          <p className="font-inter text-sm text-gray-500" data-id="element-48">
            © 2026 Sistema Keto Criollo. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-49">
            <button onClick={() => setShowPrivacy(true)} className="font-inter text-sm text-gray-400 hover:text-[#F5C518] transition-colors" data-id="element-50">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-51">|</span>
            <button onClick={() => setShowTerms(true)} className="font-inter text-sm text-gray-400 hover:text-[#F5C518] transition-colors" data-id="element-52">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} content={privacyContent} data-id="element-53" />
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} content={termsContent} data-id="element-54" />
    </>;
}